export const APP_ROUTE_NAME = {
  EMPTY: '',
  SLASH: '/',
  HOME: 'home',
  SERVICES: 'services',
  CONTACT_US: 'contact-us',
  ABOUT_US: 'about-us'
}
